const PIVCResult = ({ image, isSuccess, percentage }) => (
  <div className="flex flex-col min-h-screen bg-black pt-6 px-4 md:px-6 text-white relative overflow-hidden">
    <div className="items-center flex flex-col">
      <div className="circle-blur w-[70%] h-36 mx-auto absolute left-0 right-0 top-10 blur-[80px]"></div>

      <div className="mb-8 w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-gray-300 overflow-hidden relative z-20 bg-black/20 backdrop-blur-md">
        <img src={image} alt="face" className="w-full h-full object-cover" />
      </div>

      <div className="w-full bg-[#1D1D1D] rounded-2xl p-5 shadow-xl">
        <p className="text-gray-400 mb-2">Face Match Status</p>

        <div className="flex items-center gap-2 mb-4">
          <span
            className={`w-3 h-3 rounded-full ${
              isSuccess ? "bg-green-500" : "bg-red-500"
            }`}
          />
          <span>{isSuccess ? "Yes" : "No"}</span>
        </div>

        <p className="text-gray-400 mb-2">
          Face Match Recognized: {percentage}%
        </p>

        <div className="w-full h-3 bg-gray-700 rounded-lg overflow-hidden">
          <div
            className={`h-full ${isSuccess ? "bg-green-500" : "bg-red-500"}`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default PIVCResult;
